import { inject as o } from "vue";
const t = Symbol(), s = () => ({
  layout: o(t, "desktop")
});
export {
  t as LAYOUT_SYMBOL,
  s as useLayout
};
